import Axios from 'axios'

const location = {
  getClient (clientId) {
    return Axios.get(`api/external/clients/${clientId}`)
  },
  getClients () {
    return Axios.get(`api/internal/clients`)
  },
  addClient (client) {
    return Axios.post(`api/internal/clients`, client)
  },
  editClient (client) {
    return Axios.put(`api/internal/clients/` + client.id, client)
  }
}

export default location
